import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query/types/react/types';
import { LoginConfigApi, SetPrimaryConnectionIdDto } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseSetPrimaryConnectionId = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    SetPrimaryConnectionIdDto>,
    'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>,
  ErrorResponse,
  SetPrimaryConnectionIdDto>;

export const useSetPrimaryConnectionId: UseSetPrimaryConnectionId = (
  options,
) => {
  const loginConfigApi = new LoginConfigApi(getApiConfiguration());
  return useMutation(
    (setPrimaryConnectionIdDto: SetPrimaryConnectionIdDto) =>
      loginConfigApi.setPrimaryConnectionId(setPrimaryConnectionIdDto),
    options,
  );
};
